<template>
  <div class="empty-area">
    <img :src="imgSrc" alt="" v-if="imgSrc">
    <img src="../assets/img01.png" alt="" v-else>
    <p>{{text || '暂无数据'}}</p>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    imgSrc: {
      type: String,
      value: '',
    },
    text: {
      type: String,
      value: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-area {
  margin-top: 22vh;
  text-align: center;

  img {
    width: 160px;
  }

  p {
    padding: 10px;

    @include font(14px, 18px, $regular-text-color, center);
  }
}
</style>
